import { motion } from 'framer-motion';

export function GameStage({ bg, children, testId }) {
  return (
    <div className="fixed inset-0 overflow-hidden" data-testid={testId}>
      <div className="absolute inset-0 hidden md:block" style={{
        backgroundImage: `url(${bg})`, backgroundSize: 'cover', backgroundPosition: 'center',
        filter: 'blur(28px) brightness(0.85) saturate(1.1)', transform: 'scale(1.15)' }} />
      <div className="relative mx-auto h-[100dvh] w-full md:max-w-[520px] md:my-0 overflow-hidden md:shadow-2xl"
        style={{ backgroundImage: `url(${bg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="absolute inset-0 grain pointer-events-none" />
        {[14, 36, 58, 78, 90].map((x, i) => (
          <motion.div key={i} className="absolute w-2 h-2 rounded-full bg-white/60 pointer-events-none"
            style={{ left: `${x}%`, top: `${15 + (i * 23) % 60}%` }}
            animate={{ y: [0, -20, 0], opacity: [0.1, 0.7, 0.1] }} transition={{ repeat: Infinity, duration: 6 + i, delay: i * 0.8 }} />
        ))}
        <div className="relative h-full flex flex-col">{children}</div>
      </div>
    </div>
  );
}
